
import React from 'react';
import EventSelectionModal from '../../components/Modals/EventSelectionModal';
import BulkBookUnbookModal from '../../components/Modals/BulkBookUnbookModal';
import { BOOKING_TYPE, EVENT_STATUS_VALUES, MODALS } from '../../constants';
import { removeDuplicatesInArray } from '../../utils/common';

const EventsModals = (props) => {
  if (props.activeModal === MODALS.BULK_BOOK_UNBOOK) {
    return (
      <BulkBookUnbookModal
        cancel={props.closeModal}
        competitions={props.leagues}
        getTimezone={props.getTimezone}
        bulkBookEvents={props.bulkBookEvents}
        bulkUnbookEvents={props.bulkUnbookEvents}
        currentFilters={props.currentFilters}
        leagueFilterKey={props.isTennis ? 'filterCompetitions[]' : 'filterLeague[]'}
      />
    );
  }
  if (props.activeModal === MODALS.EVENT_SELECTION) {
    const filteredIds = props.selectableTable.state.selectedRows;
    const noDuplicateIds = removeDuplicatesInArray(filteredIds);
    const matches = noDuplicateIds.map((row) => props.events[row])
      .filter((match) => {
        if (props.isTennis) {
          return match.status === EVENT_STATUS_VALUES.FUTURE
            || match.status === EVENT_STATUS_VALUES.PRE_MATCH;
        }

        return match.status === EVENT_STATUS_VALUES.FUTURE;
      });

    return (
      <EventSelectionModal
        matches={
          props.bookingType === BOOKING_TYPE.BOOK
            ? matches.filter((match) => !match.bookedFlag)
            : matches.filter((match) => match.bookedFlag)
        }
        cancel={props.closeModal}
        confirmation={props.confirmBookings}
        leagues={props.leagues}
        bookingType={props.bookingType}
        isTennis={props.isTennis}
      />
    );
  }
  return null;
};
export default EventsModals;

